import { gql } from '@apollo/client'

export const UPDATE_EMAIL_TEMPLATE_MUTATION = gql`
  mutation UpdateEmailTemplate($id: ID!, $title: String, $subject: String, $bodyHtml: String) {
    updateEmailTemplate(id: $id, title: $title, subject: $subject, bodyHtml: $bodyHtml) {
      emailTemplate {
        id
        title
        subject
        bodyHtml
        updatedAt
      }
      errors
    }
  }
`
